module.exports = __webpack_public_path__ + "img/damir_jugo.5afbab57.png";